/*global FakeCation, document */
(function (FC) {
  "use strict";

  function cloneImageData(imgData, cnvs) {

    cnvs.width = imgData.width;
    cnvs.height = imgData.height;
    cnvs.getContext('2d').putImageData(imgData, 0, 0);
    return cnvs.getContext('2d').getImageData(0, 0, cnvs.width, cnvs.height);
  }

  FC.utils.registerFilter('userclick', function (originalImgData, cb, config) {
    var maxDiff,
      cnvs,
      modImgData,
      imgData,
      pointArray = [],
      hslDiff = config.hslDiff;
    

    cnvs = document.createElement('canvas');
    modImgData = cloneImageData(originalImgData, cnvs);

    if (config && config.x && config.y) {
      pointArray.push([config.x, config.y]);
    } else if (config && config.points) {
      pointArray = pointArray.concat(config.points);
    } else {
      pointArray.push([100, 100]);
    }

    maxDiff = config && config.maxDiff || 40;

    var matcherFn = function (currentColor, startColor) {
      var diff;
      if (hslDiff) {
        return startColor.similarHsl(currentColor, hslDiff.h, hslDiff.s, hslDiff.l) && currentColor.alpha > 0;
      }
      diff = currentColor.diffRgb(startColor);
      return startColor.similarRgb(currentColor, maxDiff) && currentColor.alpha > diff / maxDiff && currentColor.alpha > 0;
    };
    var colorFn = function (currentColor, startColor, fillColor, iData, cx, cy) {
      var c = new FC.colorUtils.Color(currentColor.red, currentColor.green, currentColor.blue),
        alpha = c.diffRgb(startColor) / maxDiff,
        modColor = FC.colorUtils.getColor(modImgData, cx, cy);

      c.alpha = Math.min(1, alpha, modColor.alpha, 0);
      fillColor.green = parseInt(c.alpha * 255, 10);

      FC.colorUtils.setColor(imgData, cx, cy, fillColor);
      FC.colorUtils.setColor(modImgData, cx, cy, c);
    };

    var point = pointArray.shift();

    function iter() {
      var x = parseInt(point[0], 10),
        y = parseInt(point[1], 10),
        color;

      imgData = cloneImageData(originalImgData, cnvs);
      color = FC.colorUtils.getColor(imgData, x, y);

      FC.colorUtils.floodFill(imgData, x, y, new FC.colorUtils.Color(255, 0, 0, 1), matcherFn, colorFn);

      {
        let ctx = FC.utils.dump(imgData);
        ctx.putImageData(imgData, 0, 0);
        ctx.rect(x - 5, y - 5, 10, 10);
        ctx.fillStyle = 'green';
        ctx.fill();
      }

      if (pointArray.length) {
        point = pointArray.shift();
        window.requestAnimationFrame(iter);
      } else {
        cb(modImgData);
      }
    }

    window.requestAnimationFrame(iter);

  });
}(FakeCation));
